<template>
  <div>
    <common-title :title="$t('common.personCenterManager')"></common-title>
    <div style="width: 800px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('common.AccountInfo')" name="first">
          <div class="ul-out">
            <el-row :gutter="20" class="in-div">
              <el-col :span="6">
                <div>{{ $t("common.account") }}</div>
              </el-col>
              <el-col :span="18">
                <div class="">
                  <span :class="loginName ? '' : 'nullSpan'">{{
                    IsNull(loginName)
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="in-div">
              <el-col :span="6"
                ><div class="">{{ $t("common.bindingEmail") }}</div></el-col
              >
              <el-col :span="11"
                ><div class="">
                  <span :class="email ? '' : 'nullSpan'">{{
                    IsNull(email)
                  }}</span>
                </div></el-col
              >
              <el-col :span="7"
                ><div class="">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleOpen('mail')"
                  >
                    <span v-if="!email">{{ $t("common.bindingEmail") }}</span>
                    <span v-if="!!email">{{ $t("common.chnageEmail") }}</span>
                  </el-button>
                </div></el-col
              >
            </el-row>
            <el-row :gutter="20" class="in-div">
              <el-col :span="6"
                ><div class="">{{ $t("common.bindingPhone") }}</div></el-col
              >
              <el-col :span="11"
                ><div class="">
                  <span :class="phoneNumber ? '' : 'nullSpan'">{{
                    IsNull(phoneNumber)
                  }}</span>
                </div></el-col
              >
              <el-col :span="7"
                ><div class="">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleOpen('phone')"
                  >
                    <span v-if="!phoneNumber">{{
                      $t("common.bindingPhone")
                    }}</span>
                    <span v-else>{{ $t("common.chnagePhone") }}</span>
                  </el-button>
                </div></el-col
              >
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('common.changePass')" name="second">
          <change-password-component></change-password-component>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      :title="
        activeWay == 'phone'
          ? $t('common.bindingPhone')
          : $t('common.bindingEmail')
      "
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
    >
      <div>
        <change-binding-components
          :activeWay="activeWay"
          @changeBinding="dialogVisibleFalse"
          :key="Math.random()"
        ></change-binding-components>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{$t("common.cancelSpace")}}</el-button>
        <!-- <el-button type="primary" @click="clickQueBtn">{{$t('common.trueText')}}</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonTitle from "@/components/common/commonTitle";
import changeBindingComponents from "@/components/personCenter/changeBindingComponents";
import changePasswordComponent from "@/components/personCenter/changePasswordComponent";
export default {
  components: {
    commonTitle,
    changeBindingComponents,
    changePasswordComponent,
  },
  data() {
    return {
      loginName: "",
      phoneNumber: null,
      email: null,

      activeName: "first",

      dialogVisible: false,

      activeWay: "",
    };
  },
  created() {
    this.getCrUserInfo();
  },
  methods: {
    getCrUserInfo() {
      this.$api.getCrUserInfo({}, "get").then((resData) => {
        if (resData.code == 200) {
          this.phoneNumber = resData.data.phone;
          this.email = resData.data.email;
          this.loginName = resData.data.account;
        } else {
          this.$message({
            message:this.$t('msg.tryAgain'),
            type: "error",
          });
        }
      });
    },
    dialogVisibleFalse(data) {
      this.dialogVisible = false;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //  弹框
    handleClose() {
      this.dialogVisible = false;
      // this.$refs['ruleForm'].resetFields();
    },
    handleOpen(activeWay) {
      this.activeWay = activeWay;
      // this.dialogTitle = "添加"
      this.dialogVisible = true;
      // if(this.$refs['ruleForm']){
      //   this.$refs['ruleForm'].resetFields();
      // }
    },
    clickQueBtn() {
      alert(2);
    },
  },
};
</script>

<style scoped lang="scss">
.ul-out {
  padding: 10px;
  .in-div {
    margin-top: 20px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
